module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"editHeatingTitle":"Heizung bearbeiten","createHeatingTitle":"Heizung erstellen","editHeatpumpTitle":"Wärmepumpe bearbeiten","createHeatpumpTitle":"Wärmepumpe erstellen"}}')
  delete Component.options._Ctor
}
